import { WidgetUUID } from '@/common/utils';
import { defineStore } from 'pinia';
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';

// NOTE: 위젯의 Threshold, Range 설정에 사용됨
export const useWidgetUnitsStore = defineStore('widgetUnitsStore', () => {
  const timeseriesWidgetUnits = ref<Record<WidgetUUID, string>>({});

  const setTimeseriesWidgetUnit = (widgetId: WidgetUUID, unit: string) => {
    timeseriesWidgetUnits.value[widgetId] = unit;
  };

  const getTimeseriesWidgetUnit = (widgetId: WidgetUUID) => {
    return timeseriesWidgetUnits.value[widgetId];
  };

  const route = useRoute();
  watch(
    () => route.params.id,
    () => {
      timeseriesWidgetUnits.value = {};
    },
  );

  return { setTimeseriesWidgetUnit, getTimeseriesWidgetUnit };
});
